/* sorting-options.js */

import FilterBtn from './filter-btn';

export default class SortingOptions extends FilterBtn {
    constructor() {
        super();
    }

    /**
     * Inits instance
     * @param node - DOM node
     */
    init(node) {
        this.BLOCK = node;
        this.BTN = this.BLOCK.querySelector('.filter-list__btn');
        this.BTN_MOBILE_TITLE = this.BLOCK.querySelector('.js-filter-list__btn-title_mobile');
        this.CONTENT = this.BLOCK.querySelector('.filter-list__item-content');
        this.DROPDOWN = this.BLOCK.querySelector('.sorting-search-results_dropdown');

        this.CONTENT.addEventListener('click', this.handleContentClick);

        this.DROPDOWN.addEventListener('focusout', this.handleFocus);

        if (this.checkOpenClass(this.BTN, 'open')) {
            this.BLOCK_STATE.hiddenContent = true;
        }

        if (this.BTN_MOBILE_TITLE) {
            this.BTN.addEventListener('click', this.handleMobileBtnClick);
        } else {
            this.BTN.addEventListener('click', this.handleBtnClick);
        }
    }

    /**
     * Handle focus out for sorting on desktop
     * @param e
     */
    handleFocus = e => {
        let target = e.target;
        if (
            this.BTN.classList.contains('open') &&
            !target.classList.contains('filter-list__btn-title')
        ) {
            this.toggleOpenClass();
        }
    };
    /**
     * Add functionality
     * @param e
     */
    handleContentClick = e => {
        let target = e.target;

        if (target.closest('.filter-list__item-content')) {
            while (!target.classList.contains('filter-list__sublist-item')) {
                target = target.parentNode;
            }
            this.toggleOpenClass();
            this.AJAX_PARAM = target.dataset.ajaxParam;
            this.createAndDispatchEvent();
        }
    };

    /**
     * Handler for mobile sorting
     * @param e
     */
    handleMobileBtnClick = e => this.toggleMobileOpenClass();

    /**
     * Show or hide sorting parameter
     */
    toggleButtonsVisibility() {
        this.BTN_MOBILE_TITLE.classList.toggle('visible');
    }

    /**
     * Handler for open and close states on mobile sorting
     */
    toggleMobileOpenClass() {
        this.toggleButtonsVisibility();
        if (!this.checkOpenClass(this.BTN, 'open')) {
            this.setOpenClass();
        } else {
            this.delOpenClass();
        }
    }
}

/* sorting-options.js */
